import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../services/local/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  private readonly svc = inject(ToastService);

  protected readonly toast = this.svc.toast;

  protected dismiss(): void {
    this.svc.dismiss();
  }
}
